import { investmentBcode } from "@equidefi/shared";
import type { DTO } from "@equidefi/shared/types";
import { ApiClient } from "./ApiClient";

class InvestmentClient extends ApiClient {
  async dispatchEvent(investmentId: string, payload: Object) {
    const response = await this.post(`/v2/investments/${investmentId}/event`, payload);

    return response.data;
  }

  async create(offering_id: string, bcode?: string, vault_id?: string, saved_profile_id?: string, ref?: string) {
    const response = await this.post("/v2/investments/", {
      offering_id,
      bcode: investmentBcode(bcode),
      ref,
      vault_id,
      saved_profile_id,
    });

    return response.data;
  }

  async addSigner(investmentId: string, payload: DTO.SigningParty) {
    const response = await this.put(`/v2/agreements/signers/${investmentId}`, payload);

    return response.data;
  }

  async setupSigners(investmentId: string) {
    const response = await this.post(`/v2/agreements/signers/${investmentId}`);

    return response.data;
  }

  async get(id: string) {
    // Not sure where it's coming from but id is showing as a string with the value undefined
    if (!id || id === "undefined") {
      return;
    }
    const response = await super.get(`/v2/investments/${id}`);
    return response.data;
  }

  async update(id: string, data = {}) {
    const response = await this.patch(`/v2/investments/${id}`, data);
    return response.data;
  }

  async cancel(id: string, reason?: string) {
    const response = await this.delete(`/v2/investments/${id}`, {
      data: { reason },
    });
    return response.data;
  }

  async updateStatusNext(id: string, data = {}) {
    const response = await this.patch(`/v2/investments/${id}/status-next`, data);
    return response.data;
  }

  async updateSubscription(id: string, data = {}) {
    const response = await this.patch(`/v2/investments/${id}/subscription`, data);
    return response.data;
  }

  async all(params: { offering_id?: string; vault_id?: string }) {
    const response = await super.get("/v2/investments", { params });
    return response.data;
  }

  async pokeInvestor(investmentId: string) {
    const response = await this.post(`/v2/investments/${investmentId}/poke`);

    return response.data;
  }

  async getInvestmentById(investmentId: string) {
    const response = await super.get(`/v2/investments/${investmentId}`);

    return response.data;
  }

  async submitSubscription(investmentId: string, payload: Object) {
    const response = await this.post(`/v2/investments/${investmentId}/subscription`, payload);

    return response.data;
  }

  async history(investmentId?: string) {
    const response = await super.get(`/v2/investments/${investmentId}/history`);
    return response.data;
  }
}

export default InvestmentClient;
